import { Component } from "react";
import * as styles from "./styles.css";
import { StepIndicator } from "../../components/atoms/step-indicator";
import { Swiper } from "../../utils/guesture";
import { UserReviewCards } from "./userReviewCard";
export class MobileView extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            this.setTimer();
        };
        this.setTimer = () => {
            if (this.props.loop) {
                this._timer = window.setInterval(() => this.setCurrent(this.state.currentStep + 1), this.props.autoplay);
            }
        };
        this.resetTimer = () => {
            if (this.props.loop) {
                clearInterval(this._timer);
                this.setTimer();
            }
        };
        this.onSwipe = (e) => {
            if (this.props.userReviews.length > 1) {
                if (e === "swiped-left") {
                    this.addCurrent();
                    this.resetTimer();
                }
                else if (e === "swiped-right") {
                    this.subCurrent();
                    this.resetTimer();
                }
            }
        };
        this.onStepIndicatorClick = (id) => {
            this.setCurrent(id + 1);
            this.resetTimer();
        };
        this.onLeftClick = () => {
            this.subCurrent();
            this.resetTimer();
        };
        this.onRightClick = () => {
            this.addCurrent();
            this.resetTimer();
        };
        this.state = {
            currentStep: 1,
            translateValue: 0,
            transitionAnimation: "transform ease-out 0.45s",
            userReviews: props && props.userReviews && props.userReviews.length > 0
                ? [
                    props.userReviews[props.userReviews.length - 1],
                    ...props.userReviews,
                    props.userReviews[0],
                ]
                : [],
        };
        this._timer = 0;
    }
    componentWillUnmount() {
        if (this._timer)
            clearInterval(this._timer);
    }
    addCurrent() {
        this.setCurrent(this.state.currentStep + 1);
    }
    subCurrent() {
        this.setCurrent(this.state.currentStep - 1);
    }
    setCurrent(id) {
        const { width } = this.props;
        const images = this.state.userReviews || [];
        const cardWidth = width <= 699 ? width - 40 : width - 120;
        this.setState({
            currentStep: id,
            translateValue: -cardWidth * (id - 1),
            transitionAnimation: "transform ease-out 0.45s",
        }, () => {
            if (this.state.currentStep === images.length - 1) {
                //for circular right
                setTimeout(() => {
                    this.setState({
                        currentStep: 1,
                        transitionAnimation: "none",
                        translateValue: 0,
                    });
                }, 450);
            }
            else if (this.state.currentStep === 0) {
                //for circular left
                setTimeout(() => {
                    this.setState({
                        currentStep: images.length - 2,
                        transitionAnimation: "none",
                        translateValue: -((images.length - 2) * 75),
                    });
                }, 450);
            }
        });
    }
    render() {
        const { width, userReviews } = this.props;
        const { translateValue, transitionAnimation, currentStep } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.wrap },
                React.createElement(Swiper, { onSwipe: this.onSwipe },
                    React.createElement("div", { className: styles.carouselItemWrapper, style: {
                            transform: `translateX(${translateValue}px)`,
                            transition: transitionAnimation,
                        } },
                        React.createElement(UserReviewCards, { userReviews: userReviews, width: width <= 699 ? width - 60 : width - 140 })))),
            userReviews.length > 1 && (React.createElement(StepIndicator, { maxStep: userReviews.length, currentStep: currentStep && currentStep - 1, onClick: this.onStepIndicatorClick, containerStyle: styles.stepIndicator }))));
    }
}

